import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translation from '../../shared/Translation';

class ViewTicketsButton extends Component {
    render() {
        return(
            <div className="confirmation-reservation__view-tickets-link">
                <a target="_blank" className="button button--primary" href={this.props.url}>
                    <Translation>{'checkout__view_tickets'}</Translation>
                </a>
            </div>
        )
    }
}

ViewTicketsButton.propTypes = {
    url: PropTypes.string,
}

export default ViewTicketsButton;
